import { API_HOST, getHttpGetOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/file`;

const getDownloadDocumentEndpoint = (externalReference) => `${getEndpoint()}/retrieve/${externalReference}`;
export const getDownloadDocumentRequest = (externalReference) => [
  getDownloadDocumentEndpoint(externalReference),
  getHttpGetOptions(undefined, undefined, 'blob'),
];
